import styled from 'styled-components';
import { AssignmentIcon } from 'ia-react-core';

export const StyledSpan = styled.span`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.black};
`;

export const StyledText = styled(StyledSpan)`
    font-weight: bold;
    opacity: 0.9;
`;

export const StyledIcon = styled(AssignmentIcon) <{ $clickable: boolean }>`
    top: 3px;
    margin-right: 8px;
    position: relative;

    ${({ $clickable, theme }) => $clickable && `
        color: ${theme.colors.blue6};
  `}
`;
